import { supabase } from "@/integrations/supabase/client";
import type { Json } from "@/integrations/supabase/types";

export type ErrorSource = "tablet" | "pdv" | "dashboard" | "public_menu" | "edge_function";

interface ErrorContext {
  tableNumber?: string;
  orderId?: string;
  productId?: string;
  comboId?: string;
  action?: string;
  [key: string]: string | number | boolean | null | undefined;
}

export async function logErrorToDatabase(
  error: unknown,
  source: ErrorSource,
  restaurantId?: string,
  context?: ErrorContext
): Promise<void> {
  try {
    const { data: { user } } = await supabase.auth.getUser();
    
    const errorObj = error as { code?: string; message?: string; stack?: string };
    
    await supabase.from("error_logs").insert([{
      restaurant_id: restaurantId || null,
      user_id: user?.id || null,
      source,
      error_code: errorObj?.code || null,
      error_message: errorObj?.message || String(error),
      error_stack: errorObj?.stack || null,
      context: (context ? JSON.parse(JSON.stringify(context)) : null) as Json,
      url: typeof window !== "undefined" ? window.location.href : null,
      user_agent: typeof navigator !== "undefined" ? navigator.userAgent : null,
    }]);
  } catch (logError) {
    // Falha silenciosa - não queremos que erro de logging cause mais erros
    console.warn("[ErrorLogger] Failed to log error to database:", logError);
  }
}

// Hook para uso em componentes React
export function useErrorLogger(restaurantId?: string) {
  const logError = async (
    error: unknown,
    source: ErrorSource,
    context?: ErrorContext
  ) => {
    await logErrorToDatabase(error, source, restaurantId, context);
  };

  return { logError };
}
